import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.scss'],
})
export class NavTabsComponent {
  @Input() tabs: Array<any> = [];
  @Output() onClick?: EventEmitter<any> = new EventEmitter<any>();

  handleClick(event: any, id: string) {
    this.onClick.emit(id);
  }
}
